import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path:
      "/dashboard/mortgage/:brand/projects/:projectId/buildings/:buildingCode/units/:unitId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/units/index"),
      loading: LoadingComponent
    })
  },
  {
    path:
      "/dashboard/mortgage/:brand/projects/:projectId/buildings/:buildingCode/units/:unitId/quotation",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/quotation/index"),
      loading: LoadingComponent
    })
  },
  {
    path:
      "/dashboard/mortgage/:brand/projects/:projectId/buildings/:buildingCode/units/:unitId/quotation/summary",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent
    })
  }
];
